webpackJsonp([70144966829960],{

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'contact-hero' },
	      _react2.default.createElement('div', { className: 'contact-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'sgeller-img-wrap' },
	      _react2.default.createElement('span', { className: 'sgeller-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'contact-title' },
	      'Steve Geller, CLFP'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'contact-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'contact-labels' },
	        'phone',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'fax',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'cell',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'email'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'contact-data' },
	        _react2.default.createElement(
	          'a',
	          { className: 'contact-data-number', href: 'tel:+1-845-362-6106' },
	          '845.362.6106'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { className: 'contact-data-number', href: 'tel:+1-815-642-0837' },
	          '815.642.0837'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { className: 'contact-data-number', href: 'tel:+1-914-552-0842' },
	          '914.552.0842'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { className: 'contact-data-email', href: 'mailto:sgeller@leasingsolutionsllc.com' },
	          'sgeller@leasingsolutionsllc.com'
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-c157bcb16ce2793a4a36.js